import {
  getFilteredObjectByValuePath,
  objectByString,
} from "@/pages/product_card/tools/object";

export const filterObject = function (obj, filter) {
  filter.every((item) => {
    let tempObjects = getFilteredObjectByValuePath(obj, item.name, item.value);

    if (Object.keys(tempObjects).length > 0) {
      obj = tempObjects;
    } else {
      return false;
    }

    return true;
  });

  return obj;
};

export const filterSameObject = function (obj, filter) {
  return Object.fromEntries(
    Object.entries(obj).filter(([, val]) => {
      let i = 0;

      filter.every((item) => {
        if (String(objectByString(val, item.name)) !== String(item.value)) {
          i++;
        }

        return true;
      });

      return i <= 1;
    })
  );
};
